export const EstadosMutuo = {
    LIQUIDADO: "LIQUIDADO",
    ACTIVADO: "ACTIVADO"
}